import { lazy } from 'react';

import type { TabCaiDat } from '../../lib/caiDatTabs.js';

/** Mục "Kết nối API" của trang Cài đặt — xem `lib/caiDatTabs.ts`. */
const caiDatTabs: TabCaiDat[] = [
  {
    id: 'ket-noi-api',
    label: 'Kết nối API',
    phu: 'Kết nối từng kênh với YouTube qua OAuth, lịch đồng bộ và dữ liệu nhập từ sao kê',
    order: 20,
    permission: { module: 'sync', level: 'view' },
    component: lazy(() =>
      import('./components/TabKetNoiApi.js').then((m) => ({ default: m.TabKetNoiApi })),
    ),
  },
];

export default caiDatTabs;
